<template>
  <div :for="context.id" :class="`custom-input-help-text input-${size}`">
    <label v-if="requiredHelpTextVisible" class="custom-required-help-text"
      ><span>* </span>{{ $t('global.validation.required') }}</label
    >
  </div>
</template>

<script>
export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  computed: {
    requiredHelpTextVisible() {
      if (!this.context.rules.find((rule) => rule.ruleName === 'required')) return false
      if (this.context.visibleValidationErrors.includes('Wajib diisi')) return false
      if (this.context.visibleValidationErrors.length > 0) return false
      if (this.context.errors.length > 0) return false
      return true
    },
  },
}
</script>

<style lang="scss">
.custom-input-help-text {
  margin-top: 4px;

  &.input-md {
    font-size: 12px;
  }

  &.input-sm {
    font-size: 11px;
  }

  .custom-required-help-text {
    font-style: italic;
    color: $mep-color-text-300;

    span {
      color: $red;
    }
  }
}
</style>
